import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchApprovalDefaults() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/approval-config/departments')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateApprovalDefault(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/approval-config/departments', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchApprovalHistory(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/approval-config/departments/${id}/history`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
